
import { computed, defineComponent, PropType } from 'vue'
import { TagVariantsEnum, TagVariantsArray, TagsVariantsMap } from './BTag.types'
export default defineComponent({
  name: 'BTag',
  props: {
    /**
     * The variant of the tag.
     */
    variant: {
      type: String as PropType<TagVariantsEnum>,
      required: false,
      default: TagVariantsEnum.PRIMARY,
      validator: (prop: TagVariantsEnum) => TagVariantsArray.includes(prop)
    },
    isCloseable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup(props, { emit}) {
    const classes = computed(() => TagsVariantsMap[props.variant])

    function onClose() {
      emit('onClose')
    }
    return {
      classes,
      onClose,
    }
  }
})
